<template>
  <Page subtype="gdpr" class="m-5 sm:m-7" :show-header="false" />
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import Page from "@components/content/page";

defineI18nRoute({
  paths: {
    cs: '/gdpr',
    en: '/privacy',
    sk: '/gdpr',
    pl: '/gdpr',
    de: '/gdpr'
  }
});

const config = useRuntimeConfig();
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.PRIVACY);

useHead({ link: [ { rel: 'canonical', href: canonical } ] });

</script>
